import { render } from "./ThePurchaseAuthorizationShow.vue?vue&type=template&id=2fcf0e57&scoped=true&ts=true"
import script from "./ThePurchaseAuthorizationShow.vue?vue&type=script&lang=ts"
export * from "./ThePurchaseAuthorizationShow.vue?vue&type=script&lang=ts"

import "./ThePurchaseAuthorizationShow.vue?vue&type=style&index=0&id=2fcf0e57&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fcf0e57"]])

export default __exports__